import Glide, { Swipe, Controls, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm';

function mount({ rootElement = null }) {
  const sliderRoot = rootElement.querySelector('.glide');
  new Glide(sliderRoot).mount({ Swipe, Controls, Breakpoints });
}

function init() {
  const blocks = document.querySelectorAll('.section--article-highlight');

  [...blocks].forEach((block) => {
    mount({ rootElement: block });
  });
}

export default init;
